import React, { useEffect } from 'react';
import { Button, Typography} from '@material-ui/core';
import { LoginLayout } from 'components';
import { shopManagerApi } from 'configs';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { showNotification } from 'redux/actions/ui';


export default () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const error = searchParams.get('error');


  useEffect(() => {
    if (error) {
      dispatch(showNotification('error', error));
    }
  }, [error]);

  return (
    <LoginLayout>
      <>
        <Typography variant="h2" className="h1 h-text-gray font-bold py-2 my-15">Welcome</Typography>
        <Button
          color="primary"
          variant="contained"
          className="w-300 my-5"
          href={`${shopManagerApi}/onelogin`}
        >
          Continue with Onelogin
        </Button>
      </>
    </LoginLayout>
  );
};
